import React from 'react'
// services
import { OfflineQueueState, OfflineStorageService } from 'services/offlineStorage'

const EMPTY_STATE: OfflineQueueState = {
  userId: '',
  mutations: [],
  tempIdMappings: {},
  fieldValueMappings: {}
}

export const useOfflineQueue = () => {
  const storage = OfflineStorageService.getInstance()

  const [state, setState] = React.useState<OfflineQueueState>(() => storage.getState() ?? EMPTY_STATE)

  React.useEffect(() => {
    const unsubscribe = storage.subscribe(() => {
      setState(storage.getState() ?? EMPTY_STATE)
    })

    return unsubscribe
  }, [storage])

  return {
    mutations: state.mutations,
    tempIdMappings: state.tempIdMappings,
    fieldValueMappings: state.fieldValueMappings,
    addMutation: storage.addMutation.bind(storage),
    removeMutation: storage.removeMutation.bind(storage),
    clearQueue: storage.clearQueue.bind(storage),
    updateTempIdMapping: storage.updateTempIdMapping.bind(storage),
    updateFieldValueMapping: storage.updateFieldValueMapping.bind(storage),
    getMutationsInOrder: storage.getMutationsInOrder.bind(storage)
  }
}
